import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Tabs } from 'ui-base';
import styles from './Tabs.module.scss';

const { Tab: BaseTab } = Tabs;

class Tab extends Component {
  handleChange = event => {
    const { onChange, value, onClick } = this.props;

    if (onChange) {
      onChange(event, value);
    }

    if (onClick) {
      onClick(event);
    }
  };

  render = () => {
    const { onChange, value, onClick, className, icon, children, success, ...rest } = this.props;
    return (
      <BaseTab
        onClick={this.handleChange}
        className={classnames(styles.item, className, {
          [styles.success]: success
        })}
        {...rest}
      >
        {icon}
        <span>{children}</span>
      </BaseTab>
    );
  };
}

Tab.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  icon: PropTypes.node,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  /**
   * You can provide your own value. Otherwise, we fallback to the child position index.
   */
  value: PropTypes.any,
  success: PropTypes.bool
};

Tab.defaultProps = {
  className: null,
  icon: null,
  onChange: undefined,
  onClick: undefined,
  value: undefined,
  success: false
};

export { Tab };
